/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const HonorsAssignmentCircledIcon = /*#__PURE__*/ createSvgIcon(
  'HonorsAssignmentCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M9.875 9.953l-1.047.797c-.052.042-.107.042-.164 0-.057-.042-.075-.094-.055-.156l.407-1.297-1.079-.844c-.052-.042-.067-.094-.046-.156.02-.063.067-.094.14-.094h1.297l.406-1.281c.021-.063.068-.094.141-.094.073 0 .12.031.14.094l.407 1.281h1.297c.073 0 .12.031.14.094.021.062.006.114-.046.156l-1.079.844.407 1.297c.02.062.002.114-.055.156-.057.042-.112.042-.164 0l-1.047-.797zm0 6.047l-2.703.594a.527.527 0 01-.477-.11.54.54 0 01-.21-.437v-3.672c-.449-.385-.808-.901-1.079-1.547A5.012 5.012 0 015 8.875c0-1.354.474-2.505 1.422-3.453S8.52 4 9.875 4c1.354 0 2.505.474 3.453 1.422S14.75 7.52 14.75 8.875c0 .667-.125 1.32-.375 1.96a3.61 3.61 0 01-1.125 1.556v3.656a.54.54 0 01-.21.437.527.527 0 01-.477.11L9.874 16zm0-3.375c1.042 0 1.927-.365 2.656-1.094.73-.729 1.094-1.614 1.094-2.656s-.365-1.927-1.094-2.656c-.729-.73-1.614-1.094-2.656-1.094s-1.927.365-2.656 1.094c-.73.729-1.094 1.614-1.094 2.656s.365 1.927 1.094 2.656c.729.73 1.614 1.094 2.656 1.094zm-2.266 2.719l2.266-.5 2.25.5v-2.156a4.518 4.518 0 01-1.086.421c-.38.094-.768.141-1.164.141a5.22 5.22 0 01-1.172-.133 3.957 3.957 0 01-1.094-.43v2.157z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default HonorsAssignmentCircledIcon;
